import { render, staticRenderFns } from "./customerservice.vue?vue&type=template&id=682fae8f"
import script from "./customerservice.vue?vue&type=script&lang=ts"
export * from "./customerservice.vue?vue&type=script&lang=ts"
import style0 from "./customerservice.vue?vue&type=style&index=0&id=682fae8f&prod&module=true&lang=stylus"
import style1 from "./customerservice.vue?vue&type=style&index=1&id=682fae8f&prod&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports